import { ExternalIsolatesCreate } from "./ExternalIsolatesCreate";
import { ExternalIsolatesList } from "./ExternalIsolatesList";
import { ExternalIsolatesShow } from "./ExternalIsolatesShow";
import { ExternalIsolatesEdit } from "./ExternalIsolatesEdit";

export const external_isolates = {
  create: ExternalIsolatesCreate,
  list: ExternalIsolatesList,
  show: ExternalIsolatesShow,
  edit: ExternalIsolatesEdit,
};
